export const BLUEPRINT_DROPDOWN_TOGGLE_PROPS = {
    icon: 'more_horiz',
    size: 'sm',
    'data-testid': 'blueprint-dropdown',
};

export enum DROPDOWN_ACTIONS {
    CREATE = 'create',
    EDIT_BASE_VIDEO = 'edit_base_video',
    EDIT_INSTRUCTIONS = 'edit_instructions',
    COPY_TO = 'copy_to',
    COPY_TO_MULTIPLE = 'copy_to_multiple',
    DELETE = 'delete',
}

export const FEW_SCENES_THRESHOLD = 3;

export const getFewScenesWarningText = (sceneCount: number) => {
    const sceneWord = sceneCount === 1 ? 'scene' : 'scenes';
    return `This blueprint has only ${sceneCount} ${sceneWord}. For longer content, the AI may need to fit more text into fewer scenes, which could affect the final result.`;
};

export const FEW_SCENES_CONSIDER_TEXT =
    'Consider using a blueprint with more scenes for longer videos.';
